import styled from 'styled-components';

const StyledCardCarousel = styled.div`
  position: relative;
  flex: 0 0 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding-right: 134px;
  img, .card--text-wrap{
    flex: 0 0 50%;
    width: 50%;
  }
  img{
    display: block;
  }
  .card--text-wrap{
    padding-left: 24px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
  }
  h6{
    margin-bottom: 24px;
  }
  p{
    color: ${props => props.theme.colors.grey_700};
  }
  @media screen and (max-width: 1439px){
    padding-right: 105px;
  }
  @media screen and (max-width: 1023px){
    padding-right: 74px;
  }
  @media screen and (max-width: 767px){
    flex-direction: column;
    padding-right: 16px;
    img, .card--text-wrap{
      padding-left: 0;
      flex: 0 0 100%;
      width: 100%;
    }
    h6{
      margin-top: 24px;
      margin-bottom: 16px;
    }
  }
`;

export {
  StyledCardCarousel,
};

